import React from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import CircularProgress from "@mui/material/CircularProgress";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { Trans, withTranslation } from "react-i18next";

import QueryBuilder from "./QueryBuilder";
import "../pages/videos/Queries.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
  }

  formatValue(v) {
    return v[0].toUpperCase() + v.substring(1);
  }

  render() {
    return (<>
      <div className="flex">
        <div className="glueBtns">
          <ToggleButtonGroup
            size="small"
            value={this.props.connection}
            data-path={this.props.path + ".connection"}
            exclusive
            onChange={this.props.handleChange.bind(
              null,
              this.props.path + ".connection",
              "change"
            )}
          >
            <ToggleButton value="and"><Trans>And</Trans></ToggleButton>
            <ToggleButton value="or"><Trans>Or</Trans></ToggleButton>
          </ToggleButtonGroup>
        </div>
        <Button
          className="Button ButtonPrimary ButtonXSmall"
          size="small"
          endIcon={<AddIcon />}
          value={"add"}
          onClick={this.props.handleChange.bind(
            null,
            this.props.path + ".query_criterions_list",
            "add"
          )}
        >
          <Trans>Add</Trans>
        </Button>
        {"name" in this.props && (
          <Button
            className="Button ButtonPrimary ButtonXSmall"
            size="small"
            endIcon={<AddIcon />}
            style={{ margin: "0 12px" }}
            onClick={this.props.handleChange.bind(
              null,
              this.props.path + ".query_states_list",
              "addgroup"
            )}
          >
            <Trans>Group</Trans>
          </Button>
        )}
        <IconButton
          color="primary"
          hidden={"name" in this.props}
          onClick={this.props.handleChange.bind(
            null,
            this.props.path,
            "remove"
          )}
          size="large">
          <ClearIcon />
        </IconButton>
      </div>
      <div>
        {this.props.query_criterions_list.map((i, k) => (
          <div className={"flex conditionRow"} key={"cond" + k}>
            <Select
              value={i.inclusion}
              variant="outlined"
              className="conditionField"
              style={{ flex: "1" }}
              onChange={this.props.handleChange.bind(
                null,
                this.props.path +
                ".query_criterions_list." +
                k +
                ".inclusion",
                "change"
              )}
            >
              <MenuItem value={true}><Trans>Include</Trans></MenuItem>
              <MenuItem value={false}><Trans>Exclude</Trans></MenuItem>
            </Select>
            <Select
              value={i.char_id}
              variant="outlined"
              className="conditionField"
              displayEmpty
              style={{ flex: "3" }}
              onChange={this.props.handleChange.bind(
                null,
                this.props.path + ".query_criterions_list." + k + ".char_id",
                "change"
              )}
            >
              {this.props.loading && (
                <MenuItem value={-2}>
                  <CircularProgress size={14} />
                </MenuItem>
              )}

              {!this.props.loading &&
                Object.keys(this.props.options).map((k) => (
                  <MenuItem value={k} key={"char" + k}>
                    {this.props.options[k].char_name}
                  </MenuItem>
                ))}
            </Select>
            {i.char_id >= -2 && (
              <>
                <Select
                  value={i.key}
                  variant="outlined"
                  className="conditionField"
                  displayEmpty
                  onChange={this.props.handleChange.bind(
                    null,
                    this.props.path + ".query_criterions_list." + k + ".key",
                    "change"
                  )}
                >
                  <MenuItem value={""}><Trans>Key</Trans></MenuItem>
                  {Object.keys(this.props.options).length > 0 &&
                    this.props.options[i.char_id].face_postures.length >
                    0 && (
                      <MenuItem value={"FACE_POSTURE"}><Trans>Face Posture</Trans></MenuItem>
                    )}
                  {Object.keys(this.props.options).length > 0 &&
                    this.props.options[i.char_id].emotions.length > 0 && (
                      <MenuItem value={"EMOTION"}><Trans>Emotions</Trans></MenuItem>
                    )}
                  {Object.keys(this.props.options).length > 0 &&
                    this.props.options[i.char_id].locations.length > 0 && (
                      <MenuItem value={"LOCATION"}><Trans>Locations</Trans></MenuItem>
                    )}
                  {Object.keys(this.props.options).length > 0 &&
                    this.props.options[i.char_id].scenes.length > 0 && (
                      <MenuItem value={"SCENE"}><Trans>Scenes</Trans></MenuItem>
                    )}
                  {Object.keys(this.props.options).length > 0 &&
                    this.props.options[i.char_id].speech && (
                      <MenuItem value={"SPEECH"}><Trans>Speech</Trans></MenuItem>
                    )}
                </Select>
                {i.key !== "SPEECH" ? (
                  <Select
                    value={i.value}
                    variant="outlined"
                    className="conditionField"
                    displayEmpty
                    onChange={this.props.handleChange.bind(
                      null,
                      this.props.path +
                      ".query_criterions_list." +
                      k +
                      ".value",
                      "change"
                    )}
                  >
                    <MenuItem value={""}><Trans>Value</Trans></MenuItem>
                    {Object.keys(this.props.options).length > 0 &&
                      i.key !== "" &&
                      this.props.options[i.char_id][
                        {
                          EMOTION: "emotions",
                          FACE_POSTURE: "face_postures",
                          LOCATION: "locations",
                          SCENE: "scenes",
                          LOGO_NAME: "logos",
                          LOGO_SIZE: "logos",
                        }[i.key]
                      ].map((j, ji) => (
                        <MenuItem value={j} key={"val" + ji}>
                          {this.formatValue(j)}
                        </MenuItem>
                      ))}
                  </Select>
                ) : (
                  <TextField
                    value={i.value}
                    variant="outlined"
                    className="conditionField"
                    hidden={i.key !== "SPEECH"}
                    onChange={this.props.handleChange.bind(
                      null,
                      this.props.path +
                      ".query_criterions_list." +
                      k +
                      ".value",
                      "change"
                    )}
                  />
                )}
              </>
            )}
            {i.char_id === -3 && (
              <>
                <Select
                  value={i.key}
                  variant="outlined"
                  className="conditionField"
                  displayEmpty
                  onChange={this.props.handleChange.bind(
                    null,
                    this.props.path + ".query_criterions_list." + k + ".key",
                    "change"
                  )}
                >
                  <MenuItem value={""}><Trans>Key</Trans></MenuItem>
                  <MenuItem value={"LOGO_NAME"}><Trans>Logo Name</Trans></MenuItem>
                  <MenuItem value={"LOGO_SIZE"}><Trans>Logo Size</Trans></MenuItem>
                </Select>
                <Select
                  value={i.value}
                  variant="outlined"
                  className="conditionField"
                  displayEmpty
                  onChange={this.props.handleChange.bind(
                    null,
                    this.props.path +
                    ".query_criterions_list." +
                    k +
                    ".value",
                    "change"
                  )}
                >
                  {i.key === "LOGO_NAME" &&
                    this.props.options[i.char_id].logos.map((k) => (
                      <MenuItem value={k} key={"logo-" + k}>
                        {k}
                      </MenuItem>
                    ))}
                  {i.key === "LOGO_SIZE" &&
                    this.props.options[i.char_id].logo_size.map((k) => (
                      <MenuItem value={k} key={"logo-" + k}>
                        {k.charAt(0).toUpperCase() + k.slice(1)}
                      </MenuItem>
                    ))}
                </Select>
              </>
            )}
            <IconButton
              color="primary"
              onClick={this.props.handleChange.bind(
                null,
                this.props.path + ".query_criterions_list." + k,
                "remove"
              )}
              size="large">
              <ClearIcon />
            </IconButton>
          </div>
        ))}
      </div>
      <div>
        {this.props.query_states_list.map((i, k) => (
          <div className={"queryGroup"} key={"group" + k}>
            <QueryBuilder
              {...i}
              handleChange={this.props.handleChange}
              path={this.props.path + ".query_states_list." + k}
              options={this.props.options}
            />
          </div>
        ))}
      </div>
    </>);
  }
}

export default withTranslation()(Index);
